import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import { getI18n } from 'client/i18n'
import styles from './edit_contribution_prefs.less'

import ContributionPrefs from 'components/contribution_prefs'
import EditForm from '../edit_form'

const i18n = getI18n('components/edit_glimpse/edit_contribution_prefs')

class EditContribtionPrefs extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    fields: PropTypes.object.isRequired,
    untouch: PropTypes.func.isRequired,
  }

  render() {
    const {
      fields: { amountType, amountAtLeast, amountExactly },
    } = this.props

    return (
      <EditForm {...this.props}>
        <div styleName="title" role="heading" aria-level="1">
          {i18n('title')}
        </div>
        <ContributionPrefs
          amountType={amountType}
          amountAtLeast={amountAtLeast}
          amountExactly={amountExactly}
          untouch={this.props.untouch}
        />
        <button
          data-pa-click="save"
          data-nemo="save"
          className="vx_btn vx_btn-block"
          styleName="save-button"
        >
          {i18n('save')}
        </button>
      </EditForm>
    )
  }
}

export default cssModules(EditContribtionPrefs, styles)
